/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_04_Detail_Tournament_2_HeadingInputs */

const en_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shock absorption at volume`)
};

const es_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absorción de impacto a volumen`)
};

const de_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stoßdämpfung bei Lautstärke`)
};

const zh_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`大量练习下吸收冲击力`)
};

const ar_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`امتصاص الصدمة عند الحجم`)
};

const fr_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absorption des chocs en volume`)
};

const vi_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hấp thụ va đập ở khối lượng lớn`)
};

const sw_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ufyonzaji wa mshtuko katika marudio mengi`)
};

const th_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การดูดซับแรงเมื่อซ้อมปริมาณมาก`)
};

const bs_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apsorpcija udara pri volumenu`)
};

const ja_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`練習量が多くても衝撃を吸収する`)
};

const ko_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`많은 연습량 속의 충격 흡수`)
};

const pt_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absorção de impacto com alto volume de treino`)
};

const it_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assorbimento degli urti ad alto volume`)
};

const sv_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stötdämpning vid stora volymer`)
};

const nl_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schokabsorptie bij hoog volume`)
};

const da_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stødabsorbering ved stor mængde`)
};

const nb_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Støtdemping ved store volumer`)
};

const fi_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iskunvaimennus suurilla toistomäärillä`)
};

const pl_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amortyzacja przy dużej liczbie powtórzeń`)
};

const ru_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поглощение удара при большом объёме`)
};

const tr_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yüksek hacimde şok emilimi`)
};

const hi_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`भारी अभ्यास में झटके को सोखना`)
};

const id_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peredaman guncangan pada volume tinggi`)
};

const ms_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyerapan hentakan pada jumlah ulangan yang tinggi`)
};

const cs_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tlumení nárazů při velkém objemu`)
};

const el_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Απορρόφηση κραδασμών σε μεγάλο όγκο`)
};

const he_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`בלימת זעזועים בנפח גבוה`)
};

const af_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skokabsorpsie by volume`)
};

const hu_method_content_step_04_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lökéscsillapítás nagy ismétlésszámnál`)
};

/**
* | output |
* | --- |
* | "Shock absorption at volume" |
*
* @param {Method_Content_Step_04_Detail_Tournament_2_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_04_detail_tournament_2_heading = /** @type {((inputs?: Method_Content_Step_04_Detail_Tournament_2_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_04_Detail_Tournament_2_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "de") return de_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "zh") return zh_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "ar") return ar_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "fr") return fr_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "vi") return vi_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "sw") return sw_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "th") return th_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "bs") return bs_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "ja") return ja_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "ko") return ko_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "pt") return pt_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "it") return it_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "sv") return sv_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "nl") return nl_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "da") return da_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "nb") return nb_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "fi") return fi_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "pl") return pl_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "ru") return ru_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "tr") return tr_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "hi") return hi_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "id") return id_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "ms") return ms_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "cs") return cs_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "el") return el_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "he") return he_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "af") return af_method_content_step_04_detail_tournament_2_heading(inputs)
	if (locale === "hu") return hu_method_content_step_04_detail_tournament_2_heading(inputs)
	return en_method_content_step_04_detail_tournament_2_heading(inputs)
});